import React, { useCallback, useEffect, useState } from 'react';
import cybersquare_sit from "../../assets/images/key.png";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Spin, message, Tabs } from 'antd';
import { global_var } from "../../services/login-config.js"
import { fetch_otp_login_details, verifyOtp } from "../../services/login-api.js";
import { trackEvent } from '../../analytics/analytics_login.js';
import './otp-login.css'
import OtpBlock from './Otp-Block.js';
import SendButton from './Send-Button.js';
import { send_otp_for_logins } from '../../services/login-api.js';
// import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const OtpLogin = () => {

  const [showContactInfo, setContactInfo] = useState(false);
  const [usernameTouched, setUsernameTouched] = useState(false);
  const [username, setUsername] = useState('');
  const [userLoginId, setUserLoginId] = useState('');
  const [buttonText, setButtonText] = useState('Next');
  const [emailAarray, setEmailArray] = useState([]);
  const [mobileAarray, setMobileArray] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([])
  const [isVerify, setIsVerify] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [otpValues, setOtpValues] = useState([]);
  const [showContactInput, setContactInput] = useState(false);
  const [emailContacInfo, setEmailContacInfo] = useState('');
  // const [mobileContacInfo, setMobileContacInfo] = useState('');
  const [activeTab, setActiveTab] = useState('email')
  // const [location, setLocation] = useState('');
  


  const getPassword = async () => {
    try {

      if (buttonText === "Next") {
        setIsLoader(true);
        setContactInfo(true);

        const response = await fetch_otp_login_details({
          "username": username,
          "company_id": global_var.companyId
        });

        setIsLoader(false);
        if (response.status === 200) {
          if (response.data.email_array && response.data.email_array.length > 0) {
            setEmailArray(response.data.email_array);
            trackEvent('forgot_password_request',{type:'Email'});
            setButtonText('Send OTP');
          }
          if (response.data.mobile_array && response.data.mobile_array.length > 0) {
            setMobileArray(response.data.mobile_array);
            trackEvent('forgot_password_request',{type:'Mobile'});
            setButtonText('Send OTP');
          }
          if (response.data.user_login_id){
            setUserLoginId(response.data.user_login_id);
            trackEvent('forgot_password_request',{type:'User_id'});
          }else{
            setErrorMessage("There is no user with the given user name.");
          }
          if (
            (!response.data.email_array || response.data.email_array.length === 0) &&
            (!response.data.mobile_array || response.data.mobile_array.length === 0)
          ) {
            setErrorMessage("No email or mobile number associated with this user ID was found");
            if (response.data.user_login_id){ 
              setUserLoginId(response.data.user_login_id);
            }
            if (response.data.enableContactField) {
              setContactInput(response.data.enableContactField)
            }
            
            setButtonText('Next');
            setContactInfo(false);
          }
        }

      } 
    } catch (error) {
      setIsLoader(false);
      setContactInfo(false);
      if (error.response) {
        const errorMessage = error.response.data.message;
        setErrorMessage(errorMessage);
        setButtonText('Next');
      }
    }

  };

  const validateOtpField = useCallback(
    () => {
      let invalid = false
      if (otpValues.length !==6) {
        invalid = true
      }
      otpValues.forEach((character)=>{
        if(character === ''){
          invalid = true
        }
      })
      setIsButtonDisabled(invalid);
  }, [otpValues]);

  useEffect(()=>{
    validateOtpField();
  },[validateOtpField])
  
  const handleUsernameChange = (event) => {
    event.target.value = event.target.value.replaceAll(' ', '');
    const newUsername = event.target.value;
    setUsername(newUsername);
    setUsernameTouched(true);
    setErrorMessage("");
    setIsLoader(false);
    setContactInfo(false);
  };

  const handleUserMailInfo = (event) => {
    const userMailInfo = event.target.value;
    setEmailContacInfo(userMailInfo)
  }

  const handleCheckboxChange = (type, index, value) => {
    // Create a new array by copying the current state
    const updatedCheckboxes = [...selectedCheckboxes];
    
    // Check if the checkbox is already in the state
    const checkboxIndex = updatedCheckboxes.findIndex(item => item.index === index && item.type === type && item.value === value);

    // If the checkbox is not in the state, add it; otherwise, remove it
    if (checkboxIndex === -1) {
      updatedCheckboxes.push({ type, index, value });
    } else {
      updatedCheckboxes.splice(checkboxIndex, 1);
    }
    // Update the state with the new array
    setSelectedCheckboxes(updatedCheckboxes);
  };

  const sendCredentials = async (type) => {
    try {
      setIsLoader(true);
      const mobile_index_array = [];
      const email_index_array = [];
      selectedCheckboxes.forEach((checkbox) => {
        if (checkbox.type === 'sms') {
          mobile_index_array.push(checkbox.index);
        } else if (checkbox.type === 'email') {
          email_index_array.push(checkbox.index);
        }
      });

      const fogotPassObj = {
        userLoginId,
        mobile_index_array,
        email_index_array,
        company_id: global_var.companyId,
      };

      const response = await send_otp_for_logins(fogotPassObj);

      if (response.status === 200) {
        setIsLoader(false);
        const valuesArray = selectedCheckboxes.map(item => item.value);
        const combinedString = valuesArray.join('/');
        message.success('OTP sent successfully to '+ combinedString);
        setIsVerify(true)
      }
    } catch (error) {
      setIsLoader(false);
      setButtonText('Send');
     

      if (error.response) {
        message.error(error.response.data.message)
      }
    }
  };

  const handleChange = (index, event) => {

    if (!/^\d$/.test(event.target.value)) {
      event.target.value = "";
    }
    otpValues[index] = event.target.value;
    const newOtpValues = [...otpValues];
    newOtpValues[index] = event.target.value || '';
    setOtpValues(newOtpValues);
  };


  const inputFocus = (elmnt) => {
    
    if (elmnt.key === 'Delete' || elmnt.key === 'Backspace') {
      const next = elmnt.target.tabIndex - 1;
      if (next > -1) {
        elmnt.target.form.elements[next].focus();
      }
    } else {
      const next = elmnt.target.tabIndex+1;
      if (next < 6 && elmnt.target.value!=='') {
        elmnt.target.form.elements[next].focus();
      }
    }
  };
  
 
  const loginWithOtp = async () => {
    try {
      const resultString = otpValues.join('')
      var userObj = {
        "userLoginId": userLoginId,
        "company_id": global_var.companyId,
        "otp": resultString
      };

      const response = await verifyOtp(userObj);
      if (response.status === 200 && response.data && response.data.access_token) {
        trackEvent('otp_login_button_clicked',{status:"otp_login_successful"});
        let domainName = 'https://' + window.location.host.replace(/.login/g,'');
    
        if (response.data.active_user_data.fkRoleId === 3) {
            domainName += '/candidate/#/home/redirect';
            trackEvent("otp_user_role_wise_login",{role: response.data.active_user_data.fkRoleName});
        } else {
            domainName += '/company/#/home/redirect';
            trackEvent("otp_user_role_wise_login",{role: response.data.active_user_data.fkRoleName});
        }
        domainName += '?access_token=' + response.data.access_token;
        localStorage.setItem('token', response.data.access_token)
        window.location.href = domainName;
    }
      
    } catch (error) {
      trackEvent('otp_login_button_clicked',{status:"otp_login_failed"});
      if (error.response) {
        message.error(error.response.data.message);
        trackEvent('otp_login_failure_reason',{message:error.response.data.message});
      }
    }
  };

  const sendDirectOtp = async () => {
    try {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // const mobileRegex = /^\d{6,15}$/;
      let contactDetails = {}


      if (activeTab === 'email') {
        if (emailContacInfo && emailRegex.test(emailContacInfo)) {
          contactDetails.email = emailContacInfo;
        } else {
          message.error('Enter a valid email address');
          return
        }
      } else if (activeTab === 'mobile') {
        // if (mobileContacInfo && mobileRegex.test(mobileContacInfo)) {
        //   contactDetails.mobile = mobileContacInfo;
        // } else {
        //   message.error('Enter a valid mobile number');
        //   return
        // }
        message.error('mobile otp service is not available yet');
       
      } else {
        message.error('sorry,an unknown error occured.');
        return
      }
      
      const fogotPassObj = {
        userLoginId,
        company_id: global_var.companyId,
        'contactDetails':contactDetails
      };
      const response = await send_otp_for_logins(fogotPassObj);

      if (response.status === 200) {
        if (emailContacInfo) {
          message.success('Successfully sent OTP to ' + emailContacInfo);
        // }else if(mobileContacInfo) {
        //   message.success('Successfully sent OTP to ' + mobileContacInfo);
        }
        setIsVerify(true)
      }
    }
    catch (error) {
      message.error('sorry,an unknown error occured.');
    }
  }

  const items = [
    { label: 'Email', key: 'email', children: <div className="form-group mb-md-3 mb-4 mt-md-5">
    <input
      type="email"
      id="userName"
      className="form-control rounded-3 border-0 input-height mb-md-3 mb-4 mt-md-5"
      placeholder="Enter your email"
      required
      value= {emailContacInfo}
      onChange={handleUserMailInfo}
    />
    <p> Your input will be noted and saved for future reference </p>
    </div> },
    // { label: 'Mobile', key: 'mobile', children: 
    // <div>
    //   <PhoneInput
    //     placeholder={'Enter your mobile number'}
    //     country={ location }
    //     containerClass={"form-group mb-md-3 mb-4 mt-md-5"}
    //     inputStyle={{ width: '100%',height:'50px' }}
    //     value={ mobileContacInfo }
    //     onChange={(mobileContacInfo) => setMobileContacInfo(mobileContacInfo)}
    //     inputProps={{
    //       name: 'phone',
    //       required: true,
    //       autoFocus: true
    //     }}
    //   /> 
    //   <p> Your input will be noted and saved for future reference </p>
      
    // </div> },
    ];

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  // useEffect(() => {
  //   const getLocation = async () => {
  //     try {
  //       if ('geolocation' in navigator) {
  //         navigator.geolocation.getCurrentPosition(
  //           async (position) => {
  //             const { latitude, longitude } = position.coords;
  //             const apiUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
  //             const response = await fetch(apiUrl);
  //             const data = await response.json();
  //             const countryCode = data.address?.country_code;
  //             setLocation(countryCode || 'in');
  //           },
  //           () => {
  //             setLocation('in');
  //           }
  //         );
  //       } else {
  //         setLocation('in');
  //       }
  //     } catch (error) {
  //       setLocation('in');
  //     }
  //   };

  //   getLocation();
  // }, []);

  return (
    <div className='container-fluid'>
      <div className='row main-background-otpLogin'>
        <div className='col-md-6 d-flex justify-content-center align-items-center'>
          <div> 
            <div className='logo-align'>
            {global_var.logo? (<img src={global_var.logo} alt={`${global_var.company_name} logo`} className='logo image-fluid' />) :null}
            </div>
            <div className='info-label-mob'>
              {!isVerify && !showContactInput && <div>
                <h3 data-testid="forgot-heading" style={{ fontWeight: "bold", fontFamily: 'Poppins' }}>Sign in using OTP</h3>
                <p style={{  fontWeight: "bold" }}>How would you like to receive OTP for login?</p>
              </div>}
              {!isVerify && showContactInput &&
                <div>
                  <h3 data-testid="forgot-heading" style={{ fontWeight: "bold", fontFamily: 'Poppins' }}>Sign in using OTP</h3>
                  <p>It seems that there is no linked email in your profile. Please enter an email to receive the OTP for login.</p>
                </div>    
              } 
              {isVerify && 
              <div>
                <h3 data-testid="forgot-heading" style={{ fontWeight: "bold", fontFamily: 'Poppins' }}>Verification</h3>
                <p style={{  fontWeight: "bold" }}>We have sent a 6 digit code to your email/mobile number. Please enter the code below</p>
              </div>}  
            </div>
            <img src={cybersquare_sit} alt="lockAndKey" className='image-responsive image-fluid' />
          </div>
        </div>
        <div className='col-md-6 col-12 d-flex justify-content-center align-items-center full-screen-mob'>
        <div id='input-box' className='col-md-8 col-12 p-md-4 p-2 rounded-4 white-background'>
          <div className='info-label'>
          {isVerify && 
            <div>
              <h3 data-testid="forgot-heading" style={{ fontWeight: "bold", fontFamily: 'Poppins' }}>Verification</h3>
              <p style={{  fontWeight: "bold" }}>We have sent a 6 digit code to your email/mobile number. Please enter the code below</p>
            </div> 
          }
          {!isVerify &&
            <div>
              <h3 data-testid="forgot-heading" style={{ fontWeight: "bold", fontFamily: 'Poppins' }}>Sign in using OTP</h3>
              {showContactInput && !isVerify &&  <p>It seems that there is no linked email or mobile number in your profile. Please enter a mobile number or email to receive the OTP for login.</p>}
            </div>    
          }          
          </div>    
          {(!showContactInfo && !showContactInput) &&  (
            <div className="form-group mb-md-3 mb-4 mt-md-5">
              <input
                type="text"
                id="userName"
                className="form-control rounded-3 border-0 input-height"
                placeholder="Enter your username"
                required
                value={username}
                onChange={handleUsernameChange}
              />
              {usernameTouched && username.trim() === '' && <label className="text-danger pt-1" data-testid="username-error">Please enter your username.</label>}
            </div>
          )}
        
          { showContactInput && !isVerify && (
             <Tabs items={items} activeKey={activeTab} onChange={handleTabChange} />
          )}

          {showContactInfo && !isLoader && !errorMessage && !isVerify && (
            <div className="form-group mb-md-3 mb-4 mt-md-5">
              <div>
                <p style={{ display: 'inline-block', marginRight: '10px', fontWeight: "bold" }}>How would you like to receive OTP for login?</p>
              </div>
              {mobileAarray.map((mobile, index) => (
                <div className="checkbox-container">
                  <input
                    type="checkbox"
                    id={`custom-checkbox-sms-${index}`}
                    checked={selectedCheckboxes.some(item => item.index === index && item.type === 'sms')}
                    onChange={() => handleCheckboxChange('sms', index, mobile)}
                    name={index}
                  />
                  <label htmlFor={`custom-checkbox-sms-${index}`} className="labelText">
                    Via SMS to {mobile}
                  </label>
                </div>
              ))}
              {emailAarray.map((email, index) => (
                <div className="checkbox-container" style={{ marginTop: '10px' }}>
                  <input
                    type="checkbox"
                    id={`custom-checkbox-email-${index}`}
                    checked={selectedCheckboxes.some(item => item.index === index && item.type === 'email')}
                    onChange={() => handleCheckboxChange('email', index, email)}
                    name={index}
                  />
                  <label htmlFor={`custom-checkbox-email-${index}`} className="labelText">
                    Via Email on {email}
                  </label>
                </div>
              ))}
            </div>
          )}
          {isLoader && (
            <div className="text-center mt-2 mb-3 mt-md-0 iconcontainer">
              <label> <Spin /></label>
            </div>
          )}
          {!isLoader && errorMessage && !showContactInput && (
            <div className="text-center mt-2 mb-3 mt-md-0 iconcontainer">
              <label data-testid="error-label">{errorMessage}</label>
            </div>
          )}
            {isVerify && 
              <div>
                <OtpBlock handleChange={handleChange} inputFocus={inputFocus} otpValues={otpValues} />
                {!showContactInput && isVerify && <p>Didn't receive the verification code? <span style={{"color":"#FF0000","cursor":"pointer"}} onClick={sendCredentials}>Resend OTP</span></p> }
                {showContactInput && isVerify && <p>Didn't receive the verification code? <span style={{"color":"#FF0000","cursor":"pointer"}} onClick={sendDirectOtp}>Resend OTP</span></p> }
                
                <button disabled={isButtonDisabled}  className="btn form-control send-button" onClick={loginWithOtp}> Sign in </button>
              </div>
            }
            {!isVerify && 
            <div>
              { !showContactInput && <SendButton isVerify={isVerify} sendCredentials={sendCredentials} getPassword={getPassword} selectedCheckboxes = {selectedCheckboxes} username={username}   buttonText={buttonText}/>}
              {showContactInput && !isVerify && <button onClick={sendDirectOtp} className="btn form-control send-button" > Send OTP </button>}
              <div className="text-center mt-5 mt-md-0 iconcontainer">
                <ArrowLeftOutlined className='text-light-blue arrowIcon' />
                <a href='/login' className='text-light-blue text-decoration-none'>Back to Sign in</a>
              </div>
            </div>
            }
        </div>
      </div>
      </div>
    </div>


  );
};

export default OtpLogin;
